//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

// Todo: Automatically generate this from templates?
// NOTE: the order of this object is important because of the use of Object.keys below
// currently instagram and tiktok have to be before social to maintain current functionality
// TODO: PD-191710 - Find another solution to determine regex with precedence
export const NAV_ACTIVE_REGEXES = {
  instagram: new RegExp('^/(instagram/.*)'),
  tiktok: new RegExp('^/(tiktok/.*)'),
  media: /^\/(explore)|(library)|(share)|(social\/organic-activity\/instagram)/,
  social: new RegExp(
    '^/(instagram/.*)|(facebook/.*)|(pinterest/.*)|(twitter/.*)|(tiktok/.*)',
  ),
  galleries: new RegExp('^/(galleries)'),
  ads: new RegExp('^/(tagging)'),
  touchpoints: new RegExp(
    '^/(fanreel/moderation)|(ads(?!.*reporting))|(like2buy/moderation)|(tilt)|' +
      '(schedule)|(social/(conversations)|(promotions)|(canvases))|(touchpoints)',
  ),
  insights: new RegExp(
    '^/(like2buy/reporting)|(fanreel/analytics)|(reveal)|' +
      '(ads/[^/]*reporting)|(organic-activity/pinterest)|(summary)|(traffic)|' +
      '(social/(brand-page/instagram)|(hashtags)|(locations)|(metrics))',
  ),
  schedule: new RegExp('^/(schedule/.*)'),
} as const;
